import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import sectionName from '../utils/sections';

export default class SectionSummary extends Component {
  view() {
    const event = this.attrs.event;
    const summary = event.sectionSummary() || {};
    const sections = JSON.parse(app.forum.attribute('florCariocaSections') || '[]');

    const sectionData = sections
      .map((section) => ({
        ...section,
        attending: summary[section.id]?.attending || 0,
      }))
      .filter((s) => s.attending > 0)
      .sort((a, b) => b.attending - a.attending);

    if (sectionData.length === 0) {
      return null;
    }

    return (
      <div className="SectionSummary">
        <h4 className="SectionSummary-title">
          <i className="fas fa-drum"></i>
          {' '}
          {app.translator.trans('florcarioca-rsvp.forum.section_summary.title')}
        </h4>
        <div className="SectionSummary-badges">
          {sectionData.map((section) => (
            <span
              className="SectionSummary-badge"
              style={{ backgroundColor: section.color }}
              title={this.getBadgeTooltip(section)}
            >
              <span className="SectionSummary-badge-name">{sectionName(section)}</span>
              <span className="SectionSummary-badge-count">
                <span className="SectionSummary-badge-attending" title="Participent">
                  {section.attending}
                </span>
              </span>
            </span>
          ))}
        </div>
      </div>
    );
  }

  getBadgeTooltip(section) {
    return `${section.attending} participent`;
  }
}
